export default "__VITE_ASSET__Bw$PE2RJ__"